import { render, staticRenderFns } from "./StatusMatrix.vue?vue&type=template&id=4ed2540c&scoped=true"
import script from "./StatusMatrix.vue?vue&type=script&lang=js"
export * from "./StatusMatrix.vue?vue&type=script&lang=js"
import style0 from "./StatusMatrix.vue?vue&type=style&index=0&id=4ed2540c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2540c",
  null
  
)

export default component.exports